import React, { useEffect, useState } from 'react'
import "./Nav.css"
import netflix  from './netflix.svg'
import laughing from  './laughing.svg'
function Nav() {
    //states
    const [show , handleShow] = useState(false)
    //scroll listener
    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 100) {
                handleShow(true);
            } else handleShow(false)
        });
        return () => {
            window.removeEventListener("scroll")
        }
    }, []);
    return (
        <div className={`nav ${show && "nav_black"}`}>
            <img className="nav_logo" src={netflix} alt="Netflix Logo" />
            <img className="nav_avatar" src={laughing} alt="Netflix Log"/>
        </div>
    )
}

export default Nav
